<template>
  <div v-if="warning" class="w2-uploader-warning">
    {{ warning }}
  </div>
  <div v-else class="w2-uploader w2-loading-parent-relative">
    <the-w2-loading v-if="loading" class="w2-uploader-loading"></the-w2-loading>
    <div class="wrap-up" :class="HideUp && 'wrap-up-hide'" ref="ref_up">
      <slot name="up">
        <!-- 默认内容-上传触发按钮 -->
        <div class="up-btn">
          {{ myCfg.upText }}
        </div>
      </slot>
    </div>

    <div class="up-tip" v-show="myCfg.upTip && !readonly">
      {{ myCfg.upTip }}
    </div>

    <!-- items向上级使用者传递 -->
    <slot name="content" :files="items">
      <!-- 默认内容-文件列表 -->
      <ul class="items">
        <li v-for="f in items" :key="f.ID">
          <div class="item-text" :title="f.Name">
            ● {{ f.Name }}
            <span class="item-size">({{ f.StringSize }})</span>
          </div>
          <div class="item-option">
            <span
              type="primary"
              @click="view(f)"
              v-show="myCfg.preview && f.CanPreview"
              >查看</span
            >
            <span
              type="primary"
              @click="down(f)"
              v-show="myCfg.download && f.URL"
              >下载</span
            >
            <span
              type="danger"
              @click="del(f)"
              v-show="myCfg.delete && !readonly"
              >删除
            </span>
          </div>
        </li>
      </ul>
      <div class="info-none" v-show="items.length == 0">未上传文件</div>
      <!-- <div class="cards">
        <div class="card" v-for="f in items" :key="f.ID">
          <div>{{f.Name}}</div>
        </div>
      </div> -->
    </slot>

    <!-- dialog -->
    <the-w2-dialog
      :visible.sync="visible"
      title="查看"
      width="98%"
      :closeOnClickModal="false"
    >
      <div style="margin: -10px -15px; min-height: 300px">
        <iframe class="w2-dialog-iframe" :src="view_url"></iframe>
      </div>
      <template v-slot:footer>
        <a @click="visible = false" class="w2-dialog-btn">取消</a>
      </template>
    </the-w2-dialog>
  </div>
</template>
<script>
// 分离出单独的组件
// slot-scope 获取插槽作用域 files
// 参考文档 http://fex.baidu.com/webuploader/getting-started.html

import TheW2Dialog from "@/w2/components/dialog";
import TheW2Loading from "@/w2/components/loading";

export default {
  name: "w2-uploader",
  components: {
    TheW2Dialog,
    TheW2Loading,
  },
  props: {
    batch: {
      type: String,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    cfg: {
      type: Object,
      default: () => ({}),
    },
    client: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      warning: "",
      items: [],
      myCfg: {},
      mobile: /(iPhone|iPad|Android|IEMobile)/gi.test(
        navigator.userAgent || ""
      ),
      visible: false,
      view_url: "",
      loading: false,
    };
  },
  computed: {
    // 提供给父组件使用
    fileList() {
      return this.items || [];
    },
    HideUp() {
      // 只读||单选且大于0个
      let a = this.readonly;
      let b = this.myCfg.multiple === false && this.items.length > 0;
      return a || b;
    },
  },
  methods: {
    dispatch(componentName, eventName, params) {
      var parent = this.$parent || this.$root;
      var name = parent.$options.componentName;

      while (parent && (!name || name !== componentName)) {
        parent = parent.$parent;

        if (parent) {
          name = parent.$options.componentName;
        }
      }
      if (parent) {
        parent.$emit.apply(parent, [eventName].concat(params));
      }
    },
    query() {
      //加载已上传的文件
      this.loading = true;
      window.ulListByBatch(this.batch, (files) => {
        this.loading = false;
        // 优化-如果有 再去赋值
        if (files.length) {
          this.items = files;
        }
      });
    },
    view(f) {
      let mobile = this.mobile;
      if (mobile) {
        // 移动端预览未做
        this.view_url = f.URLPreview;
        this.visible = true;
      } else {
        window.open(f.URLPreview);
      }
    },
    down(f) {
      window.open(f.URL);
    },
    del(f) {
      // 删除提示
      if (!confirm("确定要删除这个文件吗？\n" + f.Name)) return;
      let files = this.items;
      window.ulDelete(f.BatchId, f.ID, () => {
        // 排除掉删除的文件
        let arr = files.filter((r) => r.ID != f.ID);
        this.items = arr;
      });
    },
    initUploader() {
      // 支持client参数 如果有就传入
      let clientID = this.client.clientID;
      let clientModule = this.client.clientModule;
      let clientModuleDataID = this.client.clientModuleDataID;

      let batch = this.batch;

      let ele = this.$refs["ref_up"];

      let myCfg = this.myCfg;

      window.upload_lite_require((create) => {
        let ctrl = create({
          auto: true,
          pick: {
            id: ele,
            multiple: myCfg.multiple,
          },
          fileSingleSizeLimit: myCfg.size * 1024 * 1024,
          accept: myCfg.accept,
          batch,
          clientID,
          clientModule,
          clientModuleDataID,
        });

        // 前端错误
        ctrl.on("error", (type) => {
          let errs = {
            F_EXCEED_SIZE: "单个文件大小超过 " + myCfg.size + "MB，不能上传！",
            Q_TYPE_DENIED: "不允许上传此类型的文件！",
          };
          alert(errs[type] || type);
        });
        // 上传中
        ctrl.on("uploadProgress", () => {
          this.loading = true;
        });

        // 服务端错误  如文件相同 ios系统文件名问题
        ctrl.on("uploadError", (file, reason) => {
          if (this.loading) {
            this.loading = false;
          }

          let err = "失败-" + (file.resp ? file.resp.Error : reason);
          alert(err);
        });
        // 上传成功
        ctrl.on("fileUploaded", (file) => {
          if (this.loading) {
            this.loading = false;
          }
          this.items.push(file);
        });
      });
    },
  },
  created() {
    let baseCfg = {
      multiple: true,
      preview: true,
      download: true,
      delete: true,
      upText: "上传",
      upTip: "",
      size: 20,
    };
    this.myCfg = Object.assign({}, baseCfg, this.cfg);
    //console.log("[mycfg]", this.myCfg);
  },
  mounted() {
    if (!window.upload_lite_require) {
      return (this.warning = "[please import uploadlite]");
    }
    if (this.batch) {
      this.initUploader();
      this.query();
    } else {
      this.warning = "[please provide batch]";
    }
  },
  watch: {
    batch(v) {
      if (v && window.upload_lite_require) {
        this.initUploader();
        this.query();
        this.warning = "";
      }
    },
    items(v) {
      this.$emit("file-change", v);
      this.dispatch("ElFormItem", "el.form.change", v);
    },
  },
};
</script>
<style>
.w2-uploader-warning {
  color: #999;
  font-size: 14px;
}
.w2-uploader {
  color: #666;
  position: relative;
}

.w2-uploader .wrap-up {
  display: inline-block;
  position: relative;
  /* 解决uploaderlite触发区域扩大问题 */
}
.w2-uploader .wrap-up-hide {
  display: none;
}
.w2-uploader .up-btn {
  color: #ffffff;
  background-color: #3e88f4;
  border-color: #3e88f4;
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  font-size: 12px;
  border-radius: 3px;
  padding: 9px 12px;
  min-width: 60px;
  -webkit-appearance: none;
  text-align: center;
  box-sizing: border-box;
  outline: none;
  margin: 0;
  transition: 0.1s;
  font-weight: 500;
  user-select: none;
}

.w2-uploader .up-tip {
  font-size: 13px;
  color: #999;
}

.w2-uploader .items {
  list-style: none;
  padding: 0;
  margin: 0;
  margin-top: 10px;
}

.w2-uploader .items li {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.w2-uploader .item-text {
  flex: 1;
  color: #555;
  font-size: 14px;
  font-weight: 400;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.w2-uploader .item-size {
  font-size: 12px;
  color: #999;
}
.w2-uploader .item-option {
  width: 100px;
  text-align: right;
}
.w2-uploader .item-option span {
  color: #666;
  cursor: pointer;
  font-size: 13px;
  margin-left: 5px;
}
.w2-uploader .item-option span:hover {
  color: #3e88f4;
  text-decoration: underline;
}

/* cards */
.w2-uploader .cards {
  display: flex;
  flex-wrap: wrap;
}
.w2-uploader .card {
  box-sizing: border-box;
  width: 100px;
  height: 100px;
  padding: 10px;
  border: 1px solid #ddd;
  margin-right: 10px;
  margin-bottom: 10px;
}

/* none */
.w2-uploader .info-none {
  font-size: 13px;
  color: #999;
  font-style: italic;
}

.w2-dialog-iframe {
  border: none;
  width: 100%;
  height: 400px;
}
.w2-dialog-btn {
  font-size: 12px;
  color: #777;
  width: 56px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  border-radius: 2px;
  border: 1px solid #ddd;
}

/* 验证 */
.el-form-item.is-error .w2-uploader {
  border: 1px solid #ec4c47;
  border-radius: 4px;
}
</style>
